import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from './user.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class APIService {
    constructor(private http: HttpClient, private userService: UserService) { }

    private buildUrl(endpoint: string): string {
        const base = environment.apiBaseUrl.replace(/\/+$/,''); // trim trailing slashes
        const ep = endpoint.replace(/^\/+/, ''); // trim leading slashes
        return `${base}/${ep}`;
    }

    httpOptions() {
        const usr = this.userService.getUser();
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'id': usr.id,
                'department': usr.department,
                'userkey': `${usr.userKey}`,
                'azureusername': usr.azureUserName
            })
        };
    }

    httpOptionsNoUser() {
        return {
            headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8' })
        };
    }

    getAPINoUser(endpoint: string): Observable<any> {
        const url = this.buildUrl(endpoint);
        return this.http.get(url, this.httpOptionsNoUser());
    }

    getAPI(endpoint: string): Observable<any> {
        const url = this.buildUrl(endpoint);
        return this.http.get(url, this.httpOptions());
    }

    deleteByEndpointAPI(endpoint: string, param: any): Observable<any> {
        const url = this.buildUrl(`${endpoint}/${param}`);
        return this.http.delete(url, this.httpOptions());
    }

    postAPI(endpoint: string, payload: any): Observable<any> {
        const url = this.buildUrl(endpoint);
        return this.http.post(url, payload, this.httpOptions());
    }

    putAPI(endpoint: string, payload: any): Observable<any> {
        const url = this.buildUrl(endpoint);
        return this.http.put(url, payload, this.httpOptions());
    }
}
